import React from 'react'
import './InputModal.css'
import ReactDOM from 'react-dom'
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';

export default function InputModal({ title, children, handleCloseModal }) {
  return ReactDOM.createPortal((
    <div className="modal-background">
      <div className="modal-body" style={{ textAlign: "start" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginLeft: 25 }}>
          <Typography component="h4" variant="h5" color={'gray'}>
            {title}
          </Typography>
          <IconButton onClick={handleCloseModal}>
            <CloseIcon />
          </IconButton>
        </div>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          />
          {children}
        </Container>
      </div>
    </div>
  ), document.body)
}
